// extracted by mini-css-extract-plugin
module.exports = {"big-desktop-up":"(min-width: calc(1600 * 1px))","container":"ShopFilter_container__cYoGO","desc":"ShopFilter_desc__1vYHo","filters":"ShopFilter_filters__unT2I"};